import { Dimensions } from '@deltasierra/react-hooks-common';

const MIN_IMAGE_DIMENSION = 300;
const MAX_IMAGE_DIMENSION = 1000;

export const generateRandomDimensions = (): Dimensions => ({
    height: Math.round(Math.random() * (MAX_IMAGE_DIMENSION - MIN_IMAGE_DIMENSION)) + MIN_IMAGE_DIMENSION,
    width: Math.round(Math.random() * (MAX_IMAGE_DIMENSION - MIN_IMAGE_DIMENSION)) + MIN_IMAGE_DIMENSION,
});
